import Http from "./base-http";

class Exemption extends Http {
  deleteExemption(id) {
    return this.destroy(id);
  }
  addExemption(variables) {
    return this.create(variables);
  }
}

const exemptionObj = new Exemption({
  modelUrlPrefix : "exemption"
});

export default exemptionObj;